
import { Draft } from '../common';
import { IAddress } from 'src/types/address';
import { IPhone} from 'src/types';
import { IAIModel } from './ai';
import { merge } from 'src/generic/type/modify';
import { IDI } from 'src/types/org/di';

export interface IOrgModel {
  orgId?: string;
  name: string;
  nameShort: string;
  nameAbbr: string;
  nameShortAbbr?: string;
  nameNick?: string;
  nameFormerOfficial?: string;
  nameRoot?: string;
  visitingAddress: IAddress;
  shippingAddress?: IAddress;
  phone?: IPhone;
  fax?: IPhone;
  website?: string;
  email?: string;
  highestGradeCd?: number;
  lowestGradeCd?: number;
  orgTypeCd: number;
  orgSubTypeCd: number;
  instLvlCd?: number;
  schoolSubTypeCd?: number;
  schoolLevelCd?: number;
  campus?: boolean;
  charterInd?: boolean;
  mdrPid?: string;
  ncesId?: string;
  ipedsId?: string;
  feeWaiverId?: string;
  orgCodeNotes?: string;
  educationDeliveryMethodCds?: number[]; //K12 field
  parentOrgName?: string;
  parentOrgId?: string;
}

export interface IOrgRecord {
  org: IOrgModel;
  ais?: IAIModel[];
}

export const mergeOrg = (org: Draft<IOrgModel>, mergeOrg: Draft<IOrgModel>, type: 'add' | 'modify' | 'normal') => {
  const { phone: mergePhone, fax: mergeFax,  shippingAddress: mergeShipping, visitingAddress: mergeVisiting, ...mergeBase } = mergeOrg;
  const { phone, fax, shippingAddress, visitingAddress, ...orgBase } = org;

    //console.log(mergeBase, orgBase);
  return {
    ...orgBase,
    ...mergeBase,
    visitingAddress: merge<IAddress>(org.visitingAddress, mergeOrg.visitingAddress, type),
    shippingAddress: mergeOrg.shippingAddress ? merge<IAddress>(org.shippingAddress, mergeOrg.shippingAddress, type) : undefined,
    phone: merge<IPhone>(org.phone, mergeOrg.phone, 'modify'), // Cannot delete field values for phones atm
    fax: mergeFax ?  merge<IPhone>(org.fax, mergeOrg.fax, 'modify') : undefined
  };
};

export const mergeDi = (di: Draft<IDI>, mergeDi: Draft<IDI>, type: 'add' | 'modify' | 'normal') => {
  const { apAddress: mergeApAddress,...mergeBase } = mergeDi;
  const { apAddress,...diBase } = di;

    //console.log(mergeBase, diBase);
  return {
    ...diBase,
    ...mergeDi,
    apAddress: mergeDi.apAddress ? merge<IAddress>(di.apAddress || {}, mergeDi.apAddress, type) : undefined,
  };
};
